import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=69cdd432&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=69cdd432&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cdd432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69cdd432')) {
      api.createRecord('69cdd432', component.options)
    } else {
      api.reload('69cdd432', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=69cdd432&scoped=true", function () {
      api.rerender('69cdd432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/banner.vue"
export default component.exports